import { useSearchParams } from '@remix-run/react'
import { ReactNode, createContext, useContext, useEffect } from 'react'
import { Api } from '~/core/trpc'
import { AuthenticationClient } from '~/plugins/authentication/client'

const useInternal = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const { session } = AuthenticationClient.use()

  const userComputed = Api.userCustom.getComputed.useQuery(null, {
    enabled: session?.isLoggedIn,
  })

  useEffect(() => {
    if (session?.user?.id) {
      userComputed.refetch()
    }
  }, [session.user?.id])

  return {
    session,
    userComputed,
    searchParams,
    setSearchParams,
  }
}

type UserContext = ReturnType<typeof useInternal>

const UserContext = createContext<UserContext>(undefined)

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const value = useInternal()

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

export const useUserContext = (): UserContext => {
  const context = useContext(UserContext)

  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider')
  }

  return context
}
